import {
  Bar,
  CartesianGrid,
  BarChart as ReBarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ColumnChartBlock as ColumnChartBlockType } from '../../viz.types';
import VizBlockFrame from '../VizBlockFrame';
import VizTotal from '../VizTotal';
import { useColumnChartBlock } from './useColumnChartBlock';

interface ColumnChartBlockProps {
  block: ColumnChartBlockType;
}

const CHART_HEIGHT = 220;
const GRID_DASH = '4 4';
const BAR_MAX_SIZE = 32;

const ColumnChartBlock = ({ block }: ColumnChartBlockProps) => {
  const { formatters, chartTheme, axisTick, total, chartMargin, data } = useColumnChartBlock(block);

  return (
    <VizBlockFrame
      title={block.title}
      subtitle={block.subtitle}
      header={total && <VizTotal value={total} />}
    >
      <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
        <ReBarChart data={data} margin={chartMargin}>
          <CartesianGrid
            vertical={false}
            strokeDasharray={GRID_DASH}
            stroke={chartTheme.gridColor}
          />
          <XAxis
            dataKey="label"
            height="auto"
            interval={0}
            tick={axisTick}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            width="auto"
            tick={axisTick}
            tickLine={false}
            axisLine={false}
            tickFormatter={formatters.formatCompact}
          />
          <Tooltip
            {...chartTheme.tooltipStyles}
            cursor={false}
            separator=""
            formatter={(value) => [formatters.formatFull(Number(value)), '']}
          />
          <Bar
            dataKey="value"
            maxBarSize={BAR_MAX_SIZE}
            radius={[chartTheme.sliceCornerRadius, chartTheme.sliceCornerRadius, 0, 0]}
          />
        </ReBarChart>
      </ResponsiveContainer>
    </VizBlockFrame>
  );
};

export default ColumnChartBlock;
